module.exports = __webpack_public_path__ + "img/CONNECT_WOORECEIVER.88849826.svg";